function ShippingReportForm() {
    return {
        stockId: null,
        subStockId: null,
    };
}

export {ShippingReportForm};
